export const isTokenEncoded = (token) => decodeURIComponent(token) !== token;

export const encodeToken = (token) => (isTokenEncoded(token) ? token : encodeURIComponent(token));

const isClient = () => typeof window !== 'undefined';

export function getCasUser() {
  if (isClient()) {
    const casUser = localStorage.getItem('cas-js:user');
    if (casUser) {
      try {
        return JSON.parse(casUser);
      } catch (e) {
        console.warn('Erro ao fazer parse do usuário CAS do localStorage:', e);
        return null;
      }
    }
  }

  return null;
}

export function getUserLoginStatus() {
  const casUser = getCasUser();

  if (casUser && casUser.id_token) {
    return encodeToken(casUser.id_token);
  }

  return '';
}
